// src/auth/useAuth.js

import { useAuth } from './AuthProvider';

export default useAuth;
